module.exports = __webpack_public_path__ + "media/images/app_store_resized-2540f78bbd13d4d4c9c8b8f44056d3a6.png";